import React from "react";
import "./cardContet.scss";
import DummyLogo from "../../../../assets/icons/001.svg";
import DummyLogo1 from "../../../../assets/icons/002.svg";
import DummyLogo2 from "../../../../assets/icons/004.svg";
import DummyLogo3 from "../../../../assets/icons/005.svg";
export default function CardContet() {
  return (
    <div>
      <div className="all-card-content-alignment">
        <div className="container-lg-3">
          <div className="grid">
            <div className="grid-items">
              <div className="logo-alignment">
                <img src={DummyLogo} alt="DummyLogo" />
              </div>
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Mit mehr als 3,7 Mio. Besuchern auf der Website pro Monat
                führendes Immobilienportal Deutschlands und zusätzlich präsent
                auf Bild.de, Die-Welt.de, Abendblatt.de, ebay.de, Capital.de,
                Impulse.de, Ostsee-Zeitung.de und ca. 70 weiteren Portalen.
              </p>
            </div>
            <div className="grid-items">
              <div className="logo-alignment">
                <img src={DummyLogo1} alt="DummyLogo1" />
              </div>
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Der Marktführer mit über 7 Mio. Besuchern monatlich ist ein
                Tochterunternehmen der Telekom AG. Dessen Angebote erscheinen
                automatisch auch auf T-Online.de, Freenet.de, Quoka.de,
                Meinestadt.de und auf diversen weiteren Portalen.
              </p>
            </div>
            <div className="grid-items">
              <div className="logo-alignment">
                <img src={DummyLogo2} alt="DummyLogo2" />
              </div>
              <p
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Kalaydo.de ist ein Immobilienportal, welches von einem Verbund
                großer deutscher Tageszeitungen geführt wird. Diese sind u.a.
                Westdeutsche- Zeitung.de, Frankfurter-Rundschau, Mitteldeutsche
                Zeitung.de etc.
              </p>
            </div>
            <div className="grid-items">
              <div className="logo-alignment">
                <img src={DummyLogo3} alt="DummyLogo3" />
              </div>
              <p>
                Ein innovatives und kostenloses Portal mit diversen Angeboten.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
